var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-badge',{staticClass:"background-color-cms text-white"},[_vm._v(_vm._s(_vm.count)+" Words")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }